import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">精彩视频</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">精选专题视频内容，深度解析热门影视</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <article key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-500/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-200">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-black/60 backdrop-blur-sm text-white text-xs rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}